import axios from "axios";
import React, {Component} from "react";
import FeatherIcon from 'feather-icons-react';
import Listprint from "../../Listprint";
import { toast } from "react-toastify";

class Section extends Component{

    state = {
        rowsections : [],
        rowsectionclasses : [],
        error : "",
        loading : true,
        columnsections : [
            {
                label: 'Section',
                field: 'section',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Classe',
                field: 'classe',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Eleve',
                field: 'student',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Date',
                field: 'updated_at',
                sort: 'asc',
                width: 50
            },
            {
                label: '',
                field: 'action',
                sort: 'disabled',
                width: 50,
                printable: false
            }
        ],
        
        columnsectionclasses : [
            {
                label: 'Classe',
                field: 'classe',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Eleve',
                field: 'student',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Date',
                field: 'updated_at',
                sort: 'asc',
                width: 50
            },
            {
                label: '',
                field: 'action',
                sort: 'disabled',
                width: 50,
                printable: false
            }
        ],
    }

    async componentDidMount(){
        await this.refresh()
    }

    refresh = async () => {
        this.setState({ loading: true, error: "" })
        const results = await Promise.allSettled([this.getSections(), this.getSectionclasses()])
        this.setState({ loading: false, error: results.some((result) => result.status === "rejected") ? "Une partie de la structure scolaire n’a pas pu être chargée." : "" })
    }

    formatDate = (value) => this.props.formatDate ? this.props.formatDate(value) : new Intl.DateTimeFormat("fr-FR", { day: "2-digit", month: "short", year: "numeric" }).format(new Date(value))

    async getSections(){
        var data = await axios.get("sections/operation/Supprimer");
        if(data.status === 200)
        {
            var rows = [], somme = 0;
            data.data.map((section) => {
                var commitment_date = this.formatDate(section.updatedAt);
                const sectionclasses = Array.isArray(section.sectionclasses) ? section.sectionclasses : [];

                    somme = sectionclasses.reduce((total, classe) => total + (classe.students?.length || 0), 0);
                rows.push(
                    {
                        id: section.id,
                        section : section.short_entitled_section || "Non renseignée",
                        classe : sectionclasses.length,
                        student : somme,
                        updated_at : commitment_date ,
                        action : 
                        <span className="table_action">    
                            {
                                this.handleCheck("Modifier section") == true && (
                                    <button onClick={ () => this.restaure("sections", section.id)} className="btn text-primary rounded-3 btn-sm mx-1 p-0 m-0" title="Restaurer cet enregistrement"><FeatherIcon icon="corner-up-left" size={"10"}></FeatherIcon> </button>
                                )
                            }
                            {
                                this.handleCheck("Supprimer section") == true && (
                                    <button onClick={ () => this.delete("sections", section.id)} className="btn text-danger rounded-3 btn-sm mx-1 p-0 m-0" title="supprimer definitivement cet enregistrement"><FeatherIcon icon="x-octagon" size={"10"}></FeatherIcon> </button>
                                )
                            }
                            </span>,
                    }
                )
            })

            this.setState({
                rowsections : rows
            })
        }
    }
    

    async getSectionclasses(){
        var data = await axios.get("sectionclasses/operation/Supprimer");
        
        if(data.status === 200)
        {
            var rows = [];
            data.data.map((sectionclasse) => {
                var commitment_date = this.formatDate(sectionclasse.updatedAt);
                
                rows.push(
                    {
                        id: sectionclasse.id,
                        classe : [
                            sectionclasse.class?.short_entitled_class,
                            sectionclasse.title,
                            sectionclasse.section?.short_entitled_section
                        ].filter(Boolean).join(" ") || "Non renseignée",
                        student : sectionclasse.students?.length || 0,
                        updated_at :   commitment_date ,
                        action : 
                        <span className="table_action">    
                            {
                                this.handleCheck("Modifier classe") == true && (
                                    <button onClick={ () => this.restaure("sectionclasses", sectionclasse.id)} className="btn btn-outline-primary rounded-3 btn-sm mx-1" title="Restaurer cet enregistrement"><FeatherIcon icon="corner-up-left" size={"10"}></FeatherIcon> </button>
                                )
                            }
                            {
                                this.handleCheck("Supprimer classe") == true && (
                                    <button onClick={ () => this.delete("sectionclasses", sectionclasse.id)} className="btn btn-outline-danger rounded-3 btn-sm mx-1" title="supprimer definitivement cet enregistrement"><FeatherIcon icon="x-octagon" size={"10"}></FeatherIcon> </button>
                                )
                            }
                        </span>,
                    }
                )
            })

            this.setState({
                rowsectionclasses : rows
            })
        }
    }
    

    delete = (model, data) =>{
        if(!window.confirm("Supprimer définitivement cet élément ? Cette action est irréversible.")) return
        axios.delete(model+"/"+data).then((response) => {
            this.setState({
                rowsections : [],
                rowsectionclasses : [],
            })
            toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
            this.getSections()
            this.getSectionclasses()
        }).catch((error)=>{
            this.setState({
                error : error.response.data.msg
            })
            toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        })
    }


    restaure = (model, data) =>{
        axios.put("restaure/"+ model +"/" +data).then((response) => {
            this.setState({
                rowsections : [],
                rowsectionclasses : [],
            })
            this.getSections()
            this.getSectionclasses()
        }).catch((error)=>{})
    }

  handleCheck(val) {
    var permissions = localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) : [];
     return  permissions.some(item => val === item.permission);
 }

    renderPanel = (title, subtitle, icon, rows, columns) => (
        <section className="trash-panel">
            <header><span><FeatherIcon icon={icon} size={18}/></span><div><h2>{title}</h2><p>{subtitle}</p></div><b>{rows.length}</b></header>
            {this.state.loading ? <div className="trash-state"><FeatherIcon className="user-search-spin" icon="loader" /></div> : rows.length ? <div className="trash-list"><Listprint rows={rows} columns={columns} title={title}/></div> : <div className="trash-state trash-state--empty"><FeatherIcon icon="check-circle" size={25}/><strong>Cette corbeille est vide</strong><small>Aucun élément supprimé dans cette catégorie.</small></div>}
        </section>
    )

    render(){
        const total = this.state.rowsections.length + this.state.rowsectionclasses.length
        return <section className="trash-school">
            <div className="trash-school__heading"><div><span>Structure scolaire</span><h2>Sections et classes supprimées</h2><p>Restaurez la structure nécessaire avant de réutiliser ses rattachements.</p></div><b><FeatherIcon icon="grid" size={18}/>{total} élément{total !== 1 ? "s" : ""}</b></div>
            {this.state.error && <div className="trash-alert"><FeatherIcon icon="alert-circle" size={18}/><span>{this.state.error}</span><button type="button" onClick={this.refresh}>Réessayer</button></div>}
            <div className="trash-grid trash-grid--school">
                {this.renderPanel("Sections", "Regroupements pédagogiques", "layers", this.state.rowsections, this.state.columnsections)}
                {this.renderPanel("Classes", "Classes et niveaux associés", "book-open", this.state.rowsectionclasses, this.state.columnsectionclasses)}
            </div>
        </section>
    }
}

export default Section;
